var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-column" },
    [
      _c(
        "div",
        {
          staticClass: "screen-mode-and-save justify-content-end",
          class: { "screen-mode-and-save-scroll": _vm.isScroll }
        },
        [
          _c("div", { staticClass: "wrap-screen-mode justify-content-end" }, [
            _c(
              "button",
              { staticClass: "save-button", on: { click: _vm.submitForm } },
              [_vm._v("\n        Save\n      ")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card-page" }, [
        _c("div", { staticClass: "icon-code-editor" }, [
          _c("img", {
            attrs: { src: require("@/assets/new-form-ui/code-editor.svg") },
            on: { click: _vm.openModalCodeEditor }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "tooltip-component" }, [
            _vm._v("\n        Code Editor\n      ")
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "icon-setup-view",
            class: {
              "error-input":
                _vm.$v.dataSetup.sorting.key.$error ||
                _vm.$v.dataSetup.sorting.order.$error
            },
            on: { click: _vm.openConfiguration }
          },
          [
            _c("img", {
              attrs: { src: require("@/assets/new-form-ui/setup.svg") }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "tooltip-component" }, [
              _vm._v("\n        Configuration\n      ")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-page-content card-page-content-list-view" },
          [
            _c("div", { staticClass: "mobile-content" }, [
              _c(
                "div",
                { staticClass: "position-relative h-100" },
                [
                  _c("div", { staticClass: "wrap-list-view" }, [
                    _c("div", { staticClass: "header-view" }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/new-form-ui/hamburger-icon.svg"),
                          width: "20",
                          height: "20"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "box-title",
                          class: {
                            "error-input": _vm.$v.dataSetup.title.$error
                          },
                          on: {
                            click: function($event) {
                              _vm.openModalTitle(true)
                            }
                          }
                        },
                        [
                          _c("p", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.dataSetup.title || "...") +
                                "\n                "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "edit-or-delete",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  _vm.openModalTitle(true)
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "button" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "edit",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        _vm.openModalTitle(true)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-pencil-square-o"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "tooltip-component" },
                                      [_vm._v("Edit title")]
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "content-view" },
                      [
                        _vm.isLoading
                          ? _c("j-skeleton-summary-block")
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isLoading
                          ? _c(
                              "div",
                              { staticClass: "wrap-summary-block" },
                              [
                                _vm._l(_vm.dataSetup.summary_block, function(
                                  data,
                                  index
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            index + 1 <
                                            _vm.lengthDefaultSummaryBlockApprover,
                                          expression:
                                            "(index + 1) < lengthDefaultSummaryBlockApprover"
                                        }
                                      ],
                                      key: data.key
                                    },
                                    [
                                      _c("j-summary-workflow", {
                                        attrs: {
                                          type: "approver",
                                          "master-data":
                                            _vm.dataSetup.summary_block,
                                          data: data,
                                          index: index,
                                          "is-mobile": true
                                        },
                                        on: {
                                          "open-modal": _vm.openConfigBlock
                                        }
                                      })
                                    ],
                                    1
                                  )
                                }),
                                _vm._v(" "),
                                _c(
                                  "draggable",
                                  {
                                    staticStyle: { display: "flex" },
                                    attrs: {
                                      options: {
                                        animation: 300
                                      }
                                    },
                                    model: {
                                      value: _vm.dataSetup.summary_block,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.dataSetup,
                                          "summary_block",
                                          $$v
                                        )
                                      },
                                      expression: "dataSetup.summary_block"
                                    }
                                  },
                                  _vm._l(_vm.dataSetup.summary_block, function(
                                    data,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              index + 1 >
                                                _vm.lengthDefaultSummaryBlockApprover -
                                                  1 &&
                                              index + 1 !==
                                                _vm.dataSetup.summary_block
                                                  .length,
                                            expression:
                                              "(index + 1) > (lengthDefaultSummaryBlockApprover - 1) && (index + 1) !== dataSetup.summary_block.length"
                                          }
                                        ],
                                        key: data.key
                                      },
                                      [
                                        _c("j-summary-workflow", {
                                          attrs: {
                                            type: "approver",
                                            "master-data":
                                              _vm.dataSetup.summary_block,
                                            data: data,
                                            index: index,
                                            "extend-class": "sum-custom",
                                            "is-mobile": true
                                          },
                                          on: {
                                            "open-modal": _vm.openConfigBlock,
                                            "delete-block":
                                              _vm.deleteBlockWithoutConfirm
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  })
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "add-block mobile",
                                    on: {
                                      click: function($event) {
                                        _vm.openConfigBlock(null, null)
                                      }
                                    }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "m__r--5",
                                      attrs: {
                                        src: require("@/assets/icon/add.png"),
                                        height: "15",
                                        width: "15"
                                      }
                                    }),
                                    _vm._v(
                                      "\n                  Add Block\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _c("j-summary-workflow", {
                                      attrs: {
                                        "master-data":
                                          _vm.dataSetup.summary_block,
                                        data:
                                          _vm.dataSetup.summary_block[
                                            _vm.dataSetup.summary_block.length -
                                              1
                                          ],
                                        index:
                                          _vm.dataSetup.summary_block.length -
                                          1,
                                        "is-mobile": true
                                      },
                                      on: { "open-modal": _vm.openConfigBlock }
                                    })
                                  ],
                                  1
                                )
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "list-field" },
                          [
                            !_vm.isLoading
                              ? _c("div", { staticClass: "field" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "div-image",
                                      on: {
                                        click: function($event) {
                                          _vm.openModalField("icon")
                                        }
                                      }
                                    },
                                    [
                                      _vm.dataSetup.urlImg &&
                                      _vm.dataSetup.urlImg.includes("http")
                                        ? _c("img", {
                                            attrs: { src: _vm.dataSetup.urlImg }
                                          })
                                        : _vm.dataSetup.urlImg
                                        ? _c("span", [_vm._v("{ ... }")])
                                        : _c("span", [_vm._v("Image")]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "edit-or-delete",
                                          on: {
                                            click: function($event) {
                                              _vm.openModalField("icon")
                                            }
                                          }
                                        },
                                        [
                                          _c("div", { staticClass: "button" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "edit",
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    _vm.openModalField("icon")
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-pencil-square-o"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "tooltip-component"
                                                  },
                                                  [_vm._v("Edit icon")]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.dataSetup.urlImg
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "delete",
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        _vm.deleteField("icon")
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "fa fa-trash"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "tooltip-component"
                                                      },
                                                      [_vm._v("Delete icon")]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ])
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "wrap-text" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-items-center justify-content-between"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "field-1",
                                            class: {
                                              "error-input":
                                                _vm.$v.dataSetup.text_1.$error
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.openModalField("text_1")
                                              }
                                            }
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.dataSetup.text_1
                                                    ? "{" +
                                                        _vm.dataSetup.text_1 +
                                                        "}"
                                                    : "Field 1"
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "edit-or-delete",
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    _vm.openModalField("text_1")
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "button" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "edit",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            _vm.openModalField(
                                                              "text_1"
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-pencil-square-o"
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "tooltip-component"
                                                          },
                                                          [_vm._v("Edit field")]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.dataSetup.text_1
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "delete",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                _vm.deleteField(
                                                                  "text_1"
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-trash"
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "tooltip-component"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Delete field"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "text-field",
                                            on: {
                                              click: function($event) {
                                                _vm.openModalField("text_3")
                                              }
                                            }
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.dataSetup.text_3
                                                    ? "{" +
                                                        _vm.dataSetup.text_3 +
                                                        "}"
                                                    : "Field 3"
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "edit-or-delete",
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    _vm.openModalField("text_3")
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "button" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "edit",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            _vm.openModalField(
                                                              "text_3"
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-pencil-square-o"
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "tooltip-component"
                                                          },
                                                          [_vm._v("Edit field")]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.dataSetup.text_3
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "delete",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                _vm.deleteField(
                                                                  "text_3"
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-trash"
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "tooltip-component"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Delete field"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-items-center justify-content-between"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "field-2",
                                            on: {
                                              click: function($event) {
                                                _vm.openModalField("text_2")
                                              }
                                            }
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.dataSetup.text_2
                                                    ? "{" +
                                                        _vm.dataSetup.text_2 +
                                                        "}"
                                                    : "Field 2"
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "edit-or-delete",
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    _vm.openModalField("text_2")
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "button" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "edit",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            _vm.openModalField(
                                                              "text_2"
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-pencil-square-o"
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "tooltip-component"
                                                          },
                                                          [_vm._v("Edit field")]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.dataSetup.text_2
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "delete",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                _vm.deleteField(
                                                                  "text_2"
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-trash"
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "tooltip-component"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Delete field"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "text-field",
                                            on: {
                                              click: function($event) {
                                                _vm.openModalField("text_4")
                                              }
                                            }
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.dataSetup.text_4
                                                    ? "{" +
                                                        _vm.dataSetup.text_4 +
                                                        "}"
                                                    : "Field 4"
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "edit-or-delete",
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    _vm.openModalField("text_4")
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "button" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "edit",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            _vm.openModalField(
                                                              "text_4"
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-pencil-square-o"
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "tooltip-component"
                                                          },
                                                          [_vm._v("Edit field")]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.dataSetup.text_4
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "delete",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                _vm.deleteField(
                                                                  "text_4"
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-trash"
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "tooltip-component"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Delete field"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(3, function(index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "field" },
                                [
                                  _c("div", { staticClass: "div-image" }),
                                  _vm._v(" "),
                                  _vm._m(0, true)
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _vm.isOpenModalTitle
                    ? _c("modal-title-list-view", {
                        attrs: {
                          id: _vm.idModalTitle,
                          data: _vm.dataSetup.title
                        },
                        on: {
                          "close-modal": function($event) {
                            _vm.toggleModalTitle(false)
                          },
                          submit: _vm.submitModalTitle
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isOpenModalField
                    ? _c("modal-field-list-view", {
                        attrs: {
                          id: _vm.idModalField,
                          "variable-options": _vm.variableOptionsColumn,
                          "data-field": _vm.selectedField
                        },
                        on: {
                          "close-modal": function($event) {
                            _vm.toggleModalField(false)
                          },
                          submit: _vm.submitModalField
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-transparent m__t--15" }, [
        _vm.formDetail.list_approver_view
          ? _c(
              "span",
              {
                staticClass: "cursor-pointer",
                staticStyle: { "font-size": "14px" },
                on: {
                  click: function($event) {
                    _vm.deleteView("approver")
                  }
                }
              },
              [
                _c("i", { staticClass: "fa fa-trash" }),
                _vm._v(" "),
                _c("small", [_vm._v("Delete this view")])
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.isOpenConfiguration
        ? _c("list-view-configuration", {
            attrs: {
              id: _vm.idConfiguration,
              "data-config": _vm.dataSetup,
              "list-function": _vm.listFunction,
              variables: _vm.variableOptions,
              "variable-options": _vm.variableOptionsClass,
              "is-have-configuration": _vm.isHaveConfiguration,
              type: "approver"
            },
            on: {
              "delete-view": _vm.deleteView,
              "close-configuration": function($event) {
                _vm.toggleConfiguration(false)
              },
              submit: _vm.submitConfig
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isOpenConfigBlock
        ? _c("summary-block-configuration", {
            attrs: {
              id: _vm.idConfigBlock,
              "field-detail": _vm.selectedBlock,
              "variable-options": _vm.variableOptionsClass,
              "list-function": _vm.listFunction,
              "is-reduce-blur": true,
              type: "approver"
            },
            on: {
              "delete-configuration": _vm.deleteBlock,
              "close-configuration": function($event) {
                _vm.toggleConfigurationBlock(false)
              },
              "submit-configuration": _vm.submitBlock
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showModalFieldLibrary
        ? _c("modal-field-library", {
            attrs: { "is-reduce-blur": true },
            on: { "close-modal": _vm.closeModalFieldLibrary }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalExternalApi",
          staticClass: "modal-external-api",
          attrs: {
            "hide-header": true,
            "hide-footer": true,
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [_vm.showModalExternalUrl ? _c("modal-external-api-field") : _vm._e()],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalCodeEditor",
          staticClass: "modal-code-editor-wrap",
          attrs: {
            "hide-header": true,
            "hide-footer": true,
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _vm.showModalCodeEditor
            ? _c("modal-code-editor", {
                attrs: {
                  "view-data": _vm.viewJsonData,
                  "view-title": "List Approver View",
                  type: "list_approver_view"
                },
                on: {
                  close: _vm.closeModalCodeEditor,
                  update: _vm.updateViewByCode
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-text" }, [
      _c(
        "div",
        { staticClass: "d-flex justify-content-between align-items-center" },
        [
          _c("div", { staticClass: "skeleton-field-1" }),
          _vm._v(" "),
          _c("div", { staticClass: "skeleton-field" })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex justify-content-between align-items-center" },
        [
          _c("div", { staticClass: "skeleton-field-2" }),
          _vm._v(" "),
          _c("div", { staticClass: "skeleton-field" })
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d4979718", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4979718","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/menu/jListAppView.vue
// module id = null
// module chunks = 